import store from '../store';

function handleError(response) {
    return response.json().then(
        response => Promise.reject({
            error_code: response.error_code || 1001,
            message: response.message || '服务器繁忙，请稍后再试！',
        })
    );
}

export default {
    host: process.env.VUE_APP_API_HOST,
    get(url, data = null) {
        return this.fetch('GET', url, data);
    },

    post(url, data = null) {
        return this.fetch('POST', url, data);
    },

    // PATCH 局部更新
    put(url, data = null) {
        return this.fetch('PUT', url, data);
    },

    // PATCH 局部更新
    patch(url, data = null) {
        return this.fetch('PATCH', url, data);
    },

    // PATCH 局部更新
    del(url, data = null) {
        return this.fetch('DELETE', url, data);
    },

    fetch(method, url, data) {

        let headers = { 'Content-Type': 'application/json' };
        if (!url.startsWith('http')) {
            url = `${this.host}/${url}`;
            headers['x-user-id'] = store.getters.userId;
            headers['x-user-token'] = store.getters.userToken;
            headers['x-store-id'] = store.getters.userStoreId;
            headers['x-role'] = store.getters.userRole;
            headers['x-expiry-time'] = store.getters.userExpiryTime;
        }

        let init = {
            method,
            headers,
            // credentials: 'include',
        };

        if (data) {
            if (method === 'GET' || method === 'DELETE') {
                let params = [];

                for (let k in data) {
                    const value = data[k];
                    if (Array.isArray(value)) {
                        // 如果是数组，则为数组中的每个值生成一个单独的键值对
                        const key = `${encodeURIComponent(k)}[]`;
                        value.forEach(v => params.push(`${key}=${encodeURIComponent(v)}`));
                    } else {
                        // 不是数组，直接生成键值对
                        params.push(`${encodeURIComponent(k)}=${encodeURIComponent(value)}`);
                    }
                }
                url = `${url}?${params.join('&')}`;
            } else {
                init.body = JSON.stringify(data);
            }
        }

        return fetch(url, init).then(e => {
            if (e.status === 204) return;
            if (e.status === 200 || e.status === 201) return e.json();
            if (e.status === 404 || e.status === 403) return handleError(e);
            if (e.status === 401) {
                store.dispatch('user/logout').catch(() => {});
                return handleError(e);
            }

            return handleError(e);
        });
    },
}
